module.exports = __webpack_public_path__ + "static/media/chat-icon.e3480bdf.svg";